import React, { useEffect, useState } from "react";
import NoItemFound from "../../Components/SiteComponants/NoItemFound";
import { Link } from "react-router-dom";
import SectionHeader from "../../Components/SectionHeader/SectionHeader";
import FakeTableComponent from "../../Components/FakeTableComponent/FakeTableComponent";
import { alluser } from "./../../Datas/ProfileDatas/alluser";
import BreadCrumbs from "../../Components/BreadCrumbs/BreadCrumbs";
import { TitleSetup } from "../../Datas/Functions/titleSetup";
import MenuButton from "./../../Components/SiteComponants/MenuButton";

// handler function
const handleOptionClick = (option, id) => {
  console.log(`Selected option: ${option} - ${id}`);
};
const column = [
  {
    name: "ID",
    selector: (row) => row.id,
    sortable: "id",
  },
  {
    name: "Name",
    selector: (row) => row.name,
    sortable: "name",
  },
  {
    name: "Email",
    selector: (row) => row.email,
    sortable: "email",
  },
  {
    name: "Profile Links",
    selector: (row) => (
      <Link className="nav-item active inline-block" to={"" + row.id}>
        View Profile
      </Link>
    ),
  },
  {
    name: "Actions",
    selector: (row) => (
      // <div>
      //   <button className="site-btn p-3 mx-2 rounded w-10 h-10 hover:bg-orange-600 hover:text-white duration-200">
      //     <i className="fa fa-pen" aria-hidden="true"></i>
      //   </button>
      //   <button className="site-btn p-3 mx-2 rounded w-10 h-10 hover:bg-red-600 hover:text-white duration-200">
      //     <i className="fa fa-trash" aria-hidden="true"></i>
      //   </button>
      // </div>
      <div className="flex flex-wrap">
        <MenuButton text={"Action"}>
          <ul className="cursor-pointer ">
            <li
              className="border-y py-2 px-4 flex justify-between hover:bg-gray-300 hover:text-gray-900"
              onClick={() => handleOptionClick("Completed", row.id)}
            >
              <span>
                <i className="fa fa-check text-green-500" aria-hidden="true"></i>
              </span>
              <span>Complete</span>
            </li>
            <li
              className="border-y py-2 px-4 flex justify-between hover:bg-gray-300 hover:text-gray-900"
              onClick={() => handleOptionClick("Cancelled", row.id)}
            >
              <span>
                <i className="fa fa-times text-red-500" aria-hidden="true"></i>
              </span>
              <span>Cancel</span>
            </li>
          </ul>
        </MenuButton>
      </div>
    ),
  },
];
const selectionOption = [
  {
    title: "ID",
    value: "id",
  },
  {
    title: "Name",
    value: "name",
  },
  {
    title: "Email",
    value: "email",
  },
];
const UserList = (meta) => {
  // setting up title of this page
  TitleSetup({ ...meta });
  //********** */
  const [searchedText, setSearchedText] = useState("");
  const [selectedItem, setSelectedItem] = useState("id");
  const [datalist, setDatalist] = useState([]);
  useEffect(() => {
    setDatalist(alluser);
  }, []);
  useEffect(() => {
    const newDatalist = alluser.filter((data) =>
      String(data[selectedItem])
        .toLowerCase()
        .includes(searchedText.toLowerCase())
    );
    setDatalist(newDatalist);
  }, [searchedText, selectedItem]);

  return (
    <div className="w-full mx-2 md:container md:mx-auto">
      <SectionHeader heading={"User List"} />
      <BreadCrumbs texts={["Dashboard", "Userlist"]} />
      <FakeTableComponent
        datalist={datalist}
        column={column}
        pagination
        rowPerPageItems={[5, 10, 15, 20, 30, 40, 50, 100]}
        tableScroll
        tableScrollHeight={"500px"}
        sortIcon={<i className="fa-solid fa-caret-down"></i>}
        tableHeaderComponent={
          <h2 className="text-4xl text-center font-semibold">User List</h2>
        }
        filterComponents={[
          <div className="border-2 rounded-sm my-2 mx-3">
            <select
              className="px-3 py-2 h-full sm:w-auto w-full sm:border-r-2 sm:border-b-0 border-b focus:outline-0 "
              onChange={(e) => setSelectedItem(e.target.value)}
              defaultValue={selectedItem}
            >
              {selectionOption.map((opt, i) => (
                <option key={i} value={opt.value}>
                  Seacrh by {opt.title}
                </option>
              ))}
            </select>
            <input
              onChange={(e) => setSearchedText(e.target.value)}
              className="px-3 py-2 w-40 sm:w-52  focus:outline-0"
              placeholder={`Search...🔎`}
            />
          </div>,
        ]}
        nodataComponent={<NoItemFound msg={"No data found"} />}
      />
    </div>
  );
};

export default UserList;
